import type { IResourcesDetail } from '@/assets/types/api/Resources';

export const useMaterialStore = defineStore('materialStore', () => {
  const nuxtApp = useNuxtApp();

  /* State */

  const detail = ref<IResourcesDetail>({
    title: '',
    releaseDate: '',
    content: '',
    videoUrl: '',
    cmsDetailPageUrl: '',
    mktDetailPageUrl: '',
    abstract: '',
  });

  /* Actions */

  const USE_GET_RESOURCES_DETAIL = async (resourceId: string) => {
    /**
     * 取得指定資源素材資訊
     */
    const { $i18n, $notification } = nuxtApp;
    const { locale } = $i18n;

    return await useCustomFetch(
      () =>
        `/marketplace/api/v1/resources/detail/${resourceId}?websiteCode=${locale.value}`,
      {
        method: 'GET',
        lazy: true,
        immediate: true,
        onResponse: ({ response }) => {
          const { _data, status } = response;
          const data = _data as IResourcesDetail;

          if (status >= 200 && status < 300) {
            detail.value = { ...data };
          } else {
            console.error(_data);
            $notification({
              message: (_data as { message: string }).message,
              type: 'error',
            });
          }
        },
      }
    );
  };

  const RESET_RESOURCES_DETAIL = (): void => {
    /**
     * 重置資源素材資訊
     */
    detail.value = {
      title: '',
      releaseDate: '',
      content: '',
      videoUrl: '',
      cmsDetailPageUrl: '',
      mktDetailPageUrl: '',
      abstract: '',
    };
  };

  return {
    detail,
    USE_GET_RESOURCES_DETAIL,
    RESET_RESOURCES_DETAIL,
  };
});
